/* hs-eslint ignored failing-rules */

'use es6';

import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import UserPreferencesApi from '../../api/UserPreferencesApi';
import LanguagePreferenceSelect from './LanguagePreferenceSelect';
import UserPreferences from '../../models/UserPreferences';
import SupportLanguages from '../../constants/SupportLanguages';
import Track from '../../tracking/RepChatAssignmentTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLanguageOptions = () => Object.keys(SupportLanguages).map(key => ({
  text: I18n.text(`app.card.queue.panel.languages.${key}`),
  value: key
}));
const userPreferencesApi = new UserPreferencesApi();
function OptionsPanel(props) {
  const [primaryLanguage, setPrimaryLanguage] = useState(props.userPreferences.primaryLanguage);
  const [secondaryLanguage, setSecondaryLanguage] = useState(props.userPreferences.secondaryLanguage);
  const handleSaveButtonClick = () => {
    const updatedPreferences = new UserPreferences({
      primaryLanguage,
      secondaryLanguage
    });
    userPreferencesApi.saveUserPreferences(updatedPreferences).then(() => {
      Track.optionsApplied(updatedPreferences);
      props.setUserPreferences(updatedPreferences);
      props.onClose();
    }, error => {
      console.log(`Error saving user prefs: ${error}`);
    }).catch(console.log);
  };
  const handleCloseButtonClick = () => {
    Track.optionsClosed();
    props.onClose();
  };
  const handleSetPrimaryLanguage = newLanguage => {
    if (newLanguage === secondaryLanguage) {
      setSecondaryLanguage(undefined);
    }
    setPrimaryLanguage(newLanguage);
  };
  return /*#__PURE__*/_jsxs(Panel, {
    width: 320,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "options-panel-close",
      onClick: handleCloseButtonClick
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "options-panel-header",
          message: "app.card.queue.panel.title"
        })
      })
    }), /*#__PURE__*/_jsxs(PanelBody, {
      "data-test-id": "options-panel-body",
      padding: "300",
      children: [/*#__PURE__*/_jsx(LanguagePreferenceSelect, {
        languages: getLanguageOptions(),
        isPrimary: true,
        onChange: handleSetPrimaryLanguage,
        selectedValue: primaryLanguage
      }), /*#__PURE__*/_jsx(LanguagePreferenceSelect, {
        languages: getLanguageOptions().filter(language => language.value !== primaryLanguage),
        isPrimary: false,
        onChange: setSecondaryLanguage,
        selectedValue: secondaryLanguage
      })]
    }), /*#__PURE__*/_jsxs(PanelFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "options-panel-save",
        disabled: !primaryLanguage,
        onClick: handleSaveButtonClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.card.queue.panel.save"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "options-panel-cancel",
        onClick: handleCloseButtonClick,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.card.queue.panel.cancel"
        })
      })]
    })]
  });
}
OptionsPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  setUserPreferences: PropTypes.func.isRequired,
  userPreferences: PropTypes.instanceOf(UserPreferences)
};
export default OptionsPanel;